import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Icon from '../Icon'

class V1SelectField extends Component {
  state = {
    isClean: true,
  }

  onBlur() {
    if (!this.state.isClean) {
      return
    }
    this.setState({ isClean: false })
  }

  render() {
    const {
      classes,
      selectClassName,
      value,
      options,
      onChange,
      isRequired,
      isInvalid,
      isDisabled,
      dirty,
      plain,
      selectIconClassName,
      ...rest
    } = this.props

    return (
      <div className={classes.wrapper}>
        <select
          {...rest}
          onBlur={() => this.onBlur()}
          onChange={e => onChange && onChange(e.target.value)}
          value={value}
          className={classNames(classes.select, selectClassName, {
            [classes.plain]: plain,
            [classes.disabled]: !plain && isDisabled,
            [classes.isEditedInput]: dirty,
          })}
          required={isRequired}
          disabled={isDisabled}
        >
          {options &&
            Boolean(options.length) &&
            options.map(option => (
              <option
                value={option.value}
                key={`${option.value}${option.label}`}
                disabled={option.disabled}
              >
                {option.label}
              </option>
            ))}
        </select>

        {!plain && (
          <Icon
            name="down"
            className={classNames(classes.icon, selectIconClassName, {
              [classes.isInvalidIcon]: isInvalid,
            })}
          />
        )}
      </div>
    )
  }
}

V1SelectField.propTypes = {
  selectClassName: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  value: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  isRequired: PropTypes.bool,
  isInvalid: PropTypes.bool,
  classes: PropTypes.shape({
    wrapper: PropTypes.string,
    select: PropTypes.string,
    disabled: PropTypes.string,
    icon: PropTypes.string,
    hasValue: PropTypes.string,
    isInvalidInput: PropTypes.string,
    isInvalidIcon: PropTypes.string,
    isEditedInput: PropTypes.string,
  }),
  isDisabled: PropTypes.bool,
  dirty: PropTypes.bool,
  plain: PropTypes.bool,
  selectIconClassName: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
}

V1SelectField.defaultProps = {
  plain: false,
}

export default V1SelectField
